import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import LoginPage from './pages/LoginPage';
import FinancePage from './pages/FinancePage';
import OnboardingPage from './pages/OnboardingPage';
import AttendancePage from './pages/AttendancePage';
import AdminPage from './pages/AdminPage';
import ReportsPage from './pages/ReportsPage';
// [-- THIS IS THE FIX --] Corrected the import path
import ExcursionPage from './pages/ExcursionPage';

function Root() {
  const { user } = useAuth();
  // Redirect to a sensible default based on role
  const defaultPath = user?.role === 'Admin' ? '/admin' : user?.role === 'Finance' ? '/finance' : '/onboarding';
  return user ? <Navigate to={defaultPath} /> : <LoginPage />;
}

// A specific protected route for Admins only
const AdminRoute = ({ children }) => {
    const { user } = useAuth();
    if (user?.role !== 'Admin') {
        // Redirect non-admins to a default page they can access
        return <Navigate to="/finance" />;
    }
    return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            {/* Staff Routes */}
            <Route path="finance" element={<FinancePage />} />
            <Route path="onboarding" element={<OnboardingPage />} />
            <Route path="attendance" element={<AttendancePage />} />
            
            {/* Admin-Only Routes */}
            <Route path="excursions" element={<AdminRoute><ExcursionPage /></AdminRoute>} />
            <Route path="reports" element={<AdminRoute><ReportsPage /></AdminRoute>} />
            <Route path="admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;